import { render, staticRenderFns } from "./BestSellerList.vue?vue&type=template&id=9de42fb0&"
import script from "./BestSellerList.vue?vue&type=script&lang=js&"
export * from "./BestSellerList.vue?vue&type=script&lang=js&"
import style0 from "./BestSellerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports